module.exports = __webpack_public_path__ + "static/media/boton-home-hot-sale-.37d24325.png";